import React from 'react';
import FaceBioProvider from './useFaceBio';
import FaceBioetric from './FaceBioetric';

const FRbiometric = params => {
  return (
    <FaceBioProvider params={params}>
      <FaceBioetric />
    </FaceBioProvider>
  );
};

export default FRbiometric;
